import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import CardGrid from './CardGrid';
import './CategoryLandingTemplate.css';

const CategoryLandingTemplate = ({ data }) => {
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!`;

  return (
    <div className="category-landing-container">
      {/* Hero Section */}
      <section className="category-hero">
        <div className="category-hero-content">
          <h1 className="category-hero-title">{data.title}</h1>
          {data.intro && data.intro.map((paragraph, idx) => (
            <p key={idx} className="category-hero-intro">{paragraph}</p>
          ))}
        </div>
      </section>

      {/* Dynamic Sections */}
      {data.sections && data.sections.map((section, idx) => (
        <section key={idx} className="category-section">
          <div className="container">
            {section.heading && (
              <h2 className="section-title">{section.heading}</h2>
            )}
            <CardGrid cards={section.cards} />
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="category-cta-section">
        <div className="container">
          <h2 className="category-cta-title">
            Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos.
          </h2>
          <Button 
            size="lg" 
            className="category-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default CategoryLandingTemplate;
